export const chattingTableFilter02 = [
    {
        key: 'created_date',
        value: '대화 시작일',
    },
    {
        key: 'disable_button',
        value: '채팅 상태',
    },
    {
        key: 'from',
        value: '보낸사람명/닉네임/성별',
    },
    {
        key: null,
        value: null,
    },
    {
        key: 'to',
        value: '받는사람명/닉네임/성별',
    },
    {
        key: 'report',
        value: '신고 여부',
    },
];

export const gatheringChatFilter = [
    {
        key: 'gathering_name',
        value: '모임명',
    },
    {
        key: 'created_at',
        value: '대화 시작일',
    },
    {
        key: 'avail_yn',
        value: '채팅 상태',
    },

    {
        key: 'to',
        value: '이름/닉네임',
    },
    {
        key: null,
        value: null,
    },
    {
        key: 'from',
        value: '이름/닉네임',
    },
];

export const gatheringAllChatFilter = [
    {
        key: 'gathering_name',
        value: '모임명',
    },
    {
        key: 'to',
        value: '모임장명/닉네임',
    },
    {
        key: 'disable',
        value: '채팅 상태',
    },
];
